export const TABS_IDS = {
  ADS: 'ads',
  COLLECTIONS: 'collections',
  SHOP_BOOKMARKS: 'shop_bookmarks',
};
